function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var ImicOff = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11.6V6C15 4.34 13.66 3 12 3C10.46 3 9.21004 4.16 9.04004 5.65L15 11.6Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0793 12C17.6693 12 17.3093 12.3 17.2493 12.71C17.1993 13.03 17.1293 13.35 17.0293 13.64L18.2993 14.91C18.5993 14.31 18.8193 13.66 18.9293 12.97C18.9993 12.46 18.5993 12 18.0793 12Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71047 4.55812C3.32047 4.94813 3.32047 5.57812 3.71047 5.96812L9.00047 11.2681V11.6981C9.00047 12.8881 9.60047 14.0181 10.6305 14.6081C11.3805 15.0381 12.0405 15.0481 12.6505 14.9181L14.3105 16.5781C13.6005 16.9081 12.8105 17.0981 12.0005 17.0981C9.46047 17.0981 7.12047 15.3281 6.75047 12.7081C6.69047 12.2981 6.33047 11.9981 5.92047 11.9981C5.40047 11.9981 5.00047 12.4581 5.07047 12.9681C5.53047 15.9281 8.03047 18.2681 11.0005 18.7181V20.9981C11.0005 21.5481 11.4505 21.9981 12.0005 21.9981C12.5505 21.9981 13.0005 21.5481 13.0005 20.9981V18.7181C13.9105 18.5881 14.7705 18.2681 15.5505 17.8181L19.0405 21.3081C19.4305 21.6981 20.0605 21.6981 20.4505 21.3081C20.8405 20.9181 20.8405 20.2881 20.4505 19.8981L5.12047 4.55812C4.73047 4.16813 4.10047 4.16813 3.71047 4.55812Z",
    fill: "#495057"
  }));
});